import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY_REPORT } from "./apiRoutes";

interface UseGetPropertyReportProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyReport = async (data: any) =>
  await axiosAuth.post(`${PROPERTY_REPORT}`, data);

const useGetPropertyReport = ({
  data,
  queryParams,
}: UseGetPropertyReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-report"],
    queryFn: () => getPropertyReport(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyReport;
